import type { FC, ReactNode } from 'react'

import { Moon, Sun } from 'lucide-react'

const STORAGE_KEY = 'morph-theme'

/**
 * Deliberately stateless. Which icon shows is decided in CSS from
 * html[data-theme], so there is nothing for the server to render
 * differently from the client and no flash on hydration.
 */
export const ThemeToggle: FC = (): ReactNode => {
    const toggle = (): void => {
        const root = document.documentElement
        const next = root.getAttribute('data-theme') === 'dark' ? 'light' : 'dark'

        root.setAttribute('data-theme', next)

        try {
            localStorage.setItem(STORAGE_KEY, next)
        } catch {
            /* storage blocked: the choice still applies, it just will not persist */
        }
    }

    return (
        <button
            type='button'
            className='th-toggle'
            onClick={toggle}
            aria-label='Toggle light and dark theme'
        >
            <Moon className='th-moon size-3.5' aria-hidden />
            <Sun className='th-sun size-3.5' aria-hidden />
        </button>
    )
}
